import React from 'react';

const Preview: React.FC = () => (
  <div className="h-full bg-white flex flex-col items-center justify-center p-4">
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" className="mb-3">
      <rect width="56" height="56" rx="12" fill="#eff6ff" />
      <path d="M20 28h16M32 28l-4-4M32 28l-4 4" stroke="#2563eb" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="14" y="14" width="28" height="28" rx="6" stroke="#2563eb" strokeWidth="2" fill="none" />
    </svg>
    <div className="text-sm font-medium text-gray-700">Dashboard Reference</div>
    <div className="text-xs text-gray-400 mt-1 text-center max-w-52">
      Displays shared data from another dashboard&#39;s widget
    </div>
  </div>
);

export default Preview;
